<template>
    <div
        class="l-wrapper"
        :class="{'nav-is-open' : navIsOpen}"
    >

        <app-header
            @toggleNav="navIsOpen = !navIsOpen"
            :restaurant="restaurant"
        ></app-header>

        <app-nav></app-nav>

        <loader ref="loader" />

        <main class="l-main">
            <router-view v-if="page" :page="page" :site="site" />
        </main>

        <app-footer
            v-if="restaurant"
            :restaurant="restaurant"
        ></app-footer>

  </div>
</template>

<script>/* eslint-disable */


    import { mapGetters } from 'vuex'

    import Loader from 'components/Loader'
    import AppHeader from 'layout/AppHeader'
    import AppNav from 'layout/AppNav'
    import AppFooter from 'layout/AppFooter'

    import isEmpty from 'lodash/isEmpty'

    export default {
        data: () => ({
            navIsOpen: false,
            id: null
        }),
        components: {
            Loader,
            AppHeader,
            AppNav,
            AppFooter
        },
        computed: {

            ...mapGetters('pages', ['getPage']),

            page () {
                return this.getPage(this.id)
            },
            content () {
                return this.page.content || {}
            },
            site () {
                return this.$store.state.site.site || {}
            },
            restaurant () {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site.restaurant

            },
        },
        beforeCreate () {
            this.$store.dispatch('ueat/init')
            this.$store.dispatch('site/loadSite')
        },
        created () {
            this.setId()
            this.loadPage()
        },
        watch: {
            '$route': function (to, from) {

                this.setId()
                this.loadPage()

                this.navIsOpen = false;

                this.$refs.loader.show()

            },
            page(page) {
                if(typeof page !== 'undefined' && !isEmpty(page)) {
                    this.$refs.loader.hide()
                }
            },
        },
        methods: {

            setId() {
                this.id = this.$router.currentRoute.name
            },

            loadPage () {

                this.$store.dispatch('pages/loadPage', { id: this.id })

                // Load children pages
//                this.$store.dispatch('pages/loadPage', { id: this.id }).then(() => {
//                    this.$store.dispatch('pages/loadPageChildren', { id: this.id })
//                })
            }
        }
    }
</script>

<style>
</style>
